import { Action, SIGNED_OUT_USER } from '../../actions/index';
import { IConsentResponse, IPaymentResponse } from '../../../API/ScaTypes';
export const GET_CONSENT = 'GET_CONSENT';
export const GET_PAYMENT = 'GET_PAYMENT';

export interface ConsentState {
    loading: boolean,
    error: boolean,
    consent: IConsentResponse | null
}

export const initialConsentState: ConsentState = {
    loading: false,
    error: false,
    consent: null
}

export function getConsentReducer(state = initialConsentState, action: Action) {
    switch (action.type) {
        case `${GET_CONSENT}_PENDING`:
            return { ...state, loading: true, error: false };
        case `${GET_CONSENT}_FULFILLED`:
            return { ...state, loading: false, error: false, consent: action.payload };
        case `${GET_CONSENT}_REJECTED`:
            return { ...state, loading: false, error: true };
        case SIGNED_OUT_USER:
            return initialConsentState
        default: return state;
    }
}

export interface PaymentState {
    loading: boolean,
    error: boolean,
    payment: IPaymentResponse | null
}

export const initialPaymentState: PaymentState = {
    loading: false,
    error: false,
    payment: null
}

export function getPaymentReducer(state = initialPaymentState, action: Action) {
    switch (action.type) {
        case `${GET_PAYMENT}_PENDING`:
            return { ...state, loading: true, error: false };
        case `${GET_PAYMENT}_FULFILLED`:
            return { ...state, loading: false, error: false, payment: action.payload };
        case `${GET_PAYMENT}_REJECTED`:
            return { ...state, loading: false, error: true };
        case SIGNED_OUT_USER:
            return initialPaymentState
        default: return state;
    }
}

